import { Component } from '@angular/core';

@Component({
  selector: 'ps-ui-buyer-redirect-guide',
  templateUrl: './buyer-redirect-guide.component.html',
  styleUrls: ['./buyer-redirect-guide.component.css'],
})
export class BuyerRedirectGuideComponent {
  public fieldTransactionIdTemplate: string = '${e://Field/transaction_id}';
  constructor() {}
}
